// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ShipmentItem } from '@/shipment/api/types';
import { Decimal } from 'decimal.js';

/**
 * What a shipment is holding, summed from its lines. The shipment's own total
 * cannot cover it: held units have no asset and are excluded from the quantities
 * behind the estimate. Null when nothing is held, so a caller can tell "holding
 * nothing" from "holding zero".
 */
export function shipmentUnconfirmedTotal(
  items: ShipmentItem[]
): Decimal | null {
  const total = items.reduce(
    (sum, item) =>
      item.quarantinedEstimatedValue === null
        ? sum
        : sum.plus(new Decimal(item.quarantinedEstimatedValue)),
    new Decimal(0)
  );
  return total.isZero() ? null : total;
}
